module.exports = __webpack_public_path__ + "static/media/forearms-quizz.42365c25.jpg";